import root from './_root.js';
'use strict';
/** Built-in value references. */


var Uint8Array = root.Uint8Array;
export default Uint8Array;